import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsSliderHor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSettingsSliderHor"><Path d="M9 12.75C10.9534 12.75 12.5778 14.149 12.9287 16H21V17.5H12.9287C12.5778 19.351 10.9534 20.75 9 20.75C7.0466 20.75 5.42223 19.351 5.07129 17.5H3V16H5.07129C5.42223 14.149 7.0466 12.75 9 12.75Z" fill="currentColor"/><Path d="M15 3.25C16.9534 3.25 18.5778 4.64901 18.9287 6.5H21V8H18.9287C18.5778 9.85099 16.9534 11.25 15 11.25C13.0466 11.25 11.4222 9.85099 11.0713 8H3V6.5H11.0713C11.4222 4.64901 13.0466 3.25 15 3.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsSliderHor;
